import { render, staticRenderFns } from "./recommendPage.vue?vue&type=template&id=6506f164&scoped=true&"
import script from "./recommendPage.vue?vue&type=script&lang=js&"
export * from "./recommendPage.vue?vue&type=script&lang=js&"
import style0 from "./recommendPage.vue?vue&type=style&index=0&id=6506f164&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506f164",
  null
  
)

export default component.exports